<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">RESIDENTS' CORNER</h1>
            </div>
        </div>

        <div class="container mt-4">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: 'RESIDENTS\' CORNER', href: `/resident-corner`}

            ]" class="mb-4"/>

            <div class="row"> 
              
                <div class="md:col-2/3 lg:col-3/4 my-8">
                    <template v-if="posts.length">
                        <PostsList :posts="posts" :view="view"/>
                    </template>
                    <p v-else class="text-sm bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3">
                        There are no posts for Resident Corner yet.
                    </p>
                </div>
            </div>
         
        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import PostsList from "@app/Shared/Components/PostsList";


export default {

    mixins: [HasMetaData],

    props: {
        posts: Object,
      },

    data() {
        return {
          
            // query: {
            //     category: null,
            //     page: null,
            //     sort: null,
            //     type: null,
            //     expertiseLevels: [],
            //     view: 'list',
            //     tags: [],
            // },
            preserveScroll: true,
            viewMode: [
                {label: 'List Only', value: 'list'},
                {label: 'Including Icons', value: 'detail_view'},
            ],
            tagsKeywordList: [],
            search: '',
            openCategories: [],
        }
    },

    created() {
        this.query = _.merge(this.query, this.posts.constraints);
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        PostsList,
      
    },
    computed: {
        view: {
            get() {
                return this.query.view;
            },
            set(value) {
                this.query.view = value;
                this.query.page = null;
            }
        },
    },
    
    // mounted(){
    //     this.fetchTagsList('paginate');
    // },
};

</script>
<style scoped>
    .display-filter{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
        max-width: 400px;
    }
    .show-more {
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
        color: #3c5acf;
    }
    .search-keyword-modal {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .list-col {
        margin: 14px 0px 14px 0px;
    }
    .keyword-list-modal {
        max-width: 80%;
    }
    .search-button{
        margin-top: 36px;
    }
    .scroll-content {
        height: 377px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .scroll-content-more {
        height: 567px;
        overflow: hidden;
        overflow-y: scroll;
    }
    .anchor-color{
        color: #373737;
    }
</style>
